import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import { AlertService, VerifystudentService, AuthenticationService } from '../_services';
import { Globals } from '../_helpers';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}
interface Gender {
  value: string;
  viewValue: string;
}
interface Qualification {
  value: string;
  viewValue: string;
}
@Component({
    selector: 'assessor-verify-profile',
    templateUrl: './verify.component.html',
})

export class VerifyComponent {
    nameFormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(3),
    ]);
    emailFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern("[^ @]*@[^ @]*"),
    ]);
    mobileFormControl = new FormControl('', [
        Validators.required,
        //Validators.minLength(10),
        Validators.pattern("[0-9]{10}"),
    ]);
    aadharFormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(12),
        Validators.maxLength(12),
        Validators.pattern("[0-9]{12}"),
    ]);
    genderFormControl = new FormControl('', [ Validators.required,  ]);
    qualiFormControl = new FormControl('', [ Validators.required,  ]);
    stateFormControl = new FormControl('', [ Validators.required,  ]);
    districtFormControl = new FormControl('', [ Validators.required,  ]);  
    birthdateFormControl = new FormControl('', [
        Validators.required,
        Validators.minLength(9),
    ]);      
    matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg: string;
    returnUrl: string;
    userData = {};
    geoIPData = {};
    geoIP = '';
    city = '';
    region = '';
    postal = '';
    loc = '';
    country = '';
    latlong = '';
    userinfo: any;
    studentid: number = 0;
    usertoken;   
    high_qual: [];
    states: [];
    cities: [];
    settings = {};    
    geoType = 0;   
/*    theoryexam: number = 0;  
    vivaexam: number = 0;  */
    genders: Gender[] = [
        {value: '', viewValue: 'Please Select'},
        {value: '1', viewValue: 'Male'},
        {value: '2', viewValue: 'Female'},
        {value: '3', viewValue: 'Transgender'},        
    ];
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private verifystudentService: VerifystudentService,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) { }


    ngOnInit() {
        var step = this.route.snapshot.paramMap.get("step");
        if (step != this.globals.complSteps['verify'])
            this.returnUrl = '/';

        this.userinfo = JSON.parse(localStorage.getItem('userinfo_ps')); 
        this.settings = JSON.parse(sessionStorage.pkshn_exam_set);
        if(this.userinfo == undefined)
        {
            this.studentid = 0;
        }
        else
        {
            this.studentid = this.userinfo['student_id'];
            this.usertoken = this.userinfo['usertoken'];            
        }
        this.getQualification();
        this.myProfile();  
        this.getState();                      

    }

    public getQualification() {
        this.authenticationService.highestquali(this.globals.root_url)
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                    this.high_qual = data.high_qual;                                             
              }
              else{
                  this.high_qual = [];
              }
            }
          )
    }
studentdetails: any = [];
genderSelected: any;
qualiSelected: any;
myProfile() {
    this.loading = true;
    this.spinner.show();  
    this.authenticationService.studentprofile(this.globals.root_url, this.studentid, this.usertoken)
      .pipe(first())
      .subscribe(
        data => {
          //this.spinner.hide();
          if (data.code == 1000) {
            this.studentdetails = data.profile;
            if(this.studentdetails.gender == 1) 
              this.genderSelected = '1';
            if(this.studentdetails.gender == 2) 
              this.genderSelected = '2';   
            if(this.studentdetails.gender == 3) 
              this.genderSelected = '3';   

            this.genderFormControl.setValue(this.genderSelected);
            this.qualiSelected = this.studentdetails.id_hq;                    
            this.nameFormControl.setValue(this.studentdetails.student_name);
            this.emailFormControl.setValue(this.studentdetails.email_id);
            this.mobileFormControl.setValue(this.studentdetails.mobile_no);
            this.qualiFormControl.setValue(this.qualiSelected);
            this.loading = false;
            this.spinner.hide();
          }
          else {
            this.errorMsg = data.status;
            this.loading = false;
          }
          this.spinner.hide();
        },
        error => {
          //this.isErrorUsername = true;
          this.errorMsg = 'Invalid Data !!';
          //this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
        }
      );
  }  
    public getState() {
        this.authenticationService.states(this.globals.root_url)
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                    this.states = data.states;                                             
              }
              else{
                  this.states = [];
              }
            }
          )
    }
    public getCity() {
        this.authenticationService.cities(this.globals.root_url, this.stateFormControl.value)
          .pipe(first())
          .subscribe(
            data => {
              if (data.code == 1000) {
                    this.cities = data.cities;                                             
              }
              else{
                  this.cities = [];
              }
            }
          )
    }    
    public onSubmit(studentid) { //console.log(studentid);
        if(studentid == 0)
        {
            this.onSubmitDirect();
        }
        else
        {
            this.onSubmitMock();
        }
    }
        public onSubmitDirect() 
        {
        this.submitted = true;
        //this.genderFormControl.setValue(0);
        //this.qualiFormControl.setValue(0);

        if (this.nameFormControl.valid == false || this.genderFormControl.valid == false || this.emailFormControl.valid == false || this.mobileFormControl.valid == false || this.aadharFormControl.valid == false || this.qualiFormControl.value == '' || this.stateFormControl.value == '' || this.districtFormControl.value == '' || this.birthdateFormControl.value == '') {
            this.isErrorLogin = false;
            return false;
        }
        else 
        {
            this.loading = true;
            this.spinner.show();
            this.userData = JSON.parse(localStorage.getItem('currentUser'));
            var settings = JSON.parse(sessionStorage.pkshn_exam_set);
            this.geoIPData = JSON.parse(localStorage.getItem('supspw_geoIPStu'));
            this.geoType = JSON.parse(localStorage.getItem('supspw_geoIPStu_type'));
            var geoipresponse = this.geoIPData;
            if(this.geoType === 1)
            {
                if (geoipresponse != undefined) 
                {
                    //this.geoIP = geoipresponse['ip'];
                    //this.city = geoipresponse['city_name'];
                    //this.region = geoipresponse['district'];
                    //this.postal = geoipresponse['zip_code'];
                    //var geoAddress = geoipresponse['ip'] + ',' + geoipresponse['city_name'] + ',' + geoipresponse['district'] + ',' + geoipresponse['zip_code'] + ',' + geoipresponse['region_name'] + ',' + geoipresponse['country_name'];
                    //this.country = geoipresponse['country_name'];
                    var geoAddress = geoipresponse['display_name'];
                    this.latlong = geoipresponse['lat'] + ',' + geoipresponse['lon'];
                }
            }
            if(this.geoType === 2)
            {
                if (geoipresponse != undefined) 
                {
                    var geoAddress = geoipresponse['results'][0].formatted
                    this.latlong = geoipresponse['results'][0].geometry['lat'] + ',' + geoipresponse['results'][0].geometry['lng'];
                }
            }            
            if(settings.theory2_login == 1)
            {
                this.theory2verifyProfile();
            }
            else if(settings.entered_psyc == 1)
            {
                this.PsychoverifyProfile();
            }
            else if(settings.entered_adaptive == 1)
            {
                this.AdaptiveverifyProfile();
            }   
            else if(settings.entered_theory3 == 1)
            {
                this.theory3verifyProfile();
            }                      
            else
            {
                this.verifystudentService.createAccount(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.nameFormControl.value, this.genderFormControl.value, this.emailFormControl.value, this.mobileFormControl.value, this.qualiFormControl.value, this.aadharFormControl.value, this.stateFormControl.value, this.districtFormControl.value, this.birthdateFormControl.value, geoAddress, this.latlong, settings.exam_id)
                    .pipe(first())
                    .subscribe(
                        data => {
                            if (data.code == 1000) {
                                this.isErrorLogin = false;
                                this.authStage();
                                var info = data;
                                if(info.verify_status == 0)
                                {
                                    this.router.navigateByUrl('/checkotp/'+ info.id_self_student +'/5');
                                }
                                else
                                {
                                    if(this.userData['examstatus'] == 0 && settings.viva_assessor == 0 && (settings.module >= 2 ) && settings.viva_first == 1)
                                    {
                                        this.globals.vivaexam = 1;
                                        this.globals.theoryexam = 0;
                                    }
                                    if(this.userData['examstatus'] == 0 && (settings.module >= 2 ) && settings.viva_first == 0)
                                    {
                                        this.globals.vivaexam = 0;
                                        this.globals.theoryexam = 1;
                                    }
                                    if(this.userData['examstatus'] == 1 && (settings.module >= 2 ) && settings.viva_first == 0)
                                    {
                                        this.globals.vivaexam = 1;
                                        this.globals.theoryexam = 0;
                                    }        
                                    if(this.userData['examstatus'] == 2 && settings.viva_assessor == 0 && (settings.module >= 2 ) && settings.viva_first == 1)
                                    {
                                        this.globals.vivaexam = 0;
                                        this.globals.theoryexam = 1;
                                    }
                                    if(this.userData['examstatus'] == 2 && settings.viva_assessor == 1 && (settings.module >= 2 ) && settings.viva_first == 1)
                                    {
                                        this.globals.vivaexam = 0;
                                        this.globals.theoryexam = 1;
                                    }                                     
                                            if(this.userData['examstatus'] == 0 && settings.module == 1)
                                    {
                                        this.globals.vivaexam = 0;
                                        this.globals.theoryexam = 1;
                                    }                             
                                    if (settings.camera == 1 && this.globals.theoryexam == 1) {
                                        var parms = this.globals.getRandUrl('upload-idpic');
                                        this.router.navigateByUrl('/upload-idpic/' + parms);
                                    }
                                        else {
                                            if (settings.feedback_survey == 1) {
                                               //  console.log(settings.feedback_survey);
                                               this.router.navigateByUrl('/start-feedback');                                
                                            } 
                                            else
                                            {
                                                var parms = this.globals.getRandUrl('test-start');
                                                this.router.navigateByUrl('/test-start/' + parms);
                                            }                                  
                                        }
                                }    
                            }
                            else if (data.status == 1001) {
                                this.loading = false;
                                this.isErrorLogin = false;
                                this.router.navigateByUrl('/login');
                            }
                            else {
                                this.isErrorLogin = true;
                                this.errorMsg = 'This is incorrect information!!';
                                this.loading = false;
                            }
                            this.spinner.hide();
                        },
                        error => {
                            this.isErrorLogin = true;
                            this.errorMsg = 'This is incorrect information!!';
                            this.alertService.error(error);
                            this.loading = false;
                            this.spinner.hide();
                        }
                    );
            }
        }
    }    
        public theory2verifyProfile() {
            this.loading = true;
            this.spinner.show();
            this.userData = JSON.parse(localStorage.getItem('currentUser'));
            var settings = JSON.parse(sessionStorage.pkshn_exam_set);
            this.geoIPData = JSON.parse(localStorage.getItem('supspw_geoIPStu'));
            this.geoType = JSON.parse(localStorage.getItem('supspw_geoIPStu_type'));
            var geoipresponse = this.geoIPData;
            if(this.geoType === 1)
            {
                if (geoipresponse != undefined) 
                {
                    var geoAddress = geoipresponse['display_name'];
                    this.latlong = geoipresponse['lat'] + ',' + geoipresponse['lon'];
                }
            }
            if(this.geoType === 2)
            {
                if (geoipresponse != undefined) 
                {
                    var geoAddress = geoipresponse['results'][0].formatted
                    this.latlong = geoipresponse['results'][0].geometry['lat'] + ',' + geoipresponse['results'][0].geometry['lng'];
                }
            }  

            this.verifystudentService.verifyStudenttheory2(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.nameFormControl.value, this.genderFormControl.value, this.emailFormControl.value, this.mobileFormControl.value, this.qualiFormControl.value, this.aadharFormControl.value, this.stateFormControl.value, this.districtFormControl.value, geoAddress, this.latlong, settings.exam_id, this.birthdateFormControl.value)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {
                            this.isErrorLogin = false;

                            if(this.userData['examstatus'] == 0 && settings.viva_assessor == 0 && (settings.module >= 2 ) && settings.viva_first == 1)
                            {
                                this.globals.vivaexam = 1;
                                this.globals.theoryexam = 0;
                            }
                            if(this.userData['examstatus'] == 0 && (settings.module >= 2 ) && settings.viva_first == 0)
                            {
                                this.globals.vivaexam = 0;
                                this.globals.theoryexam = 1;
                            }
                            if(this.userData['examstatus'] == 1 && (settings.module >= 2 ) && settings.viva_first == 0)
                            {
                                this.globals.vivaexam = 1;
                                this.globals.theoryexam = 0;
                            }        
                            if(this.userData['examstatus'] == 2 && settings.viva_assessor == 0 && (settings.module >= 2 ) && settings.viva_first == 1)
                            {
                                this.globals.vivaexam = 0;
                                this.globals.theoryexam = 1;
                            }
                            if(this.userData['examstatus'] == 2 && settings.viva_assessor == 1 && (settings.module >= 2 ) && settings.viva_first == 1)
                            {
                                this.globals.vivaexam = 0;
                                this.globals.theoryexam = 1;
                            }                             
                            if(this.userData['examstatus'] == 0 && settings.module == 1)
                            {
                                this.globals.vivaexam = 0;
                                this.globals.theoryexam = 1;
                            }                             
                            if (settings.camera == 1 && this.globals.theoryexam == 1) {
                                var parms = this.globals.getRandUrl('upload-idpic');
                                this.router.navigateByUrl('/upload-idpic/' + parms);
                            }
                            else {
                                var parms = this.globals.getRandUrl('test-start');
                                this.router.navigateByUrl('/test-start/' + parms);                                  
                            }
                        }
                        else if (data.status == 1001) {
                            this.loading = false;
                            this.isErrorLogin = false;
                            this.router.navigateByUrl('/login');
                        }
                        else {
                            this.isErrorLogin = true;
                            this.errorMsg = 'This is incorrect information!!';
                            this.loading = false;
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.isErrorLogin = true;
                        this.errorMsg = 'This is incorrect information!!';
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
    }
        public PsychoverifyProfile() {
            this.loading = true;
            this.spinner.show();
            this.userData = JSON.parse(localStorage.getItem('currentUser'));
            var settings = JSON.parse(sessionStorage.pkshn_exam_set);
            this.geoIPData = JSON.parse(localStorage.getItem('supspw_geoIPStu'));
            this.geoType = JSON.parse(localStorage.getItem('supspw_geoIPStu_type'));
            var geoipresponse = this.geoIPData;
            if(this.geoType === 1)
            {
                if (geoipresponse != undefined) 
                {
                    var geoAddress = geoipresponse['display_name'];
                    this.latlong = geoipresponse['lat'] + ',' + geoipresponse['lon'];
                }
            }
            if(this.geoType === 2)
            {
                if (geoipresponse != undefined) 
                {
                    var geoAddress = geoipresponse['results'][0].formatted
                    this.latlong = geoipresponse['results'][0].geometry['lat'] + ',' + geoipresponse['results'][0].geometry['lng'];
                }
            } 

            this.verifystudentService.verifyStudentPsycho(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.nameFormControl.value, this.genderFormControl.value, this.emailFormControl.value, this.mobileFormControl.value, this.qualiFormControl.value, this.aadharFormControl.value, this.stateFormControl.value, this.districtFormControl.value, geoAddress, this.latlong, settings.exam_id, this.birthdateFormControl.value)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {
                            this.isErrorLogin = false;

                            if(this.userData['examstatus'] == 0 && settings.viva_assessor == 0 && (settings.module >= 2 ) && settings.viva_first == 1)
                            {
                                this.globals.vivaexam = 1;
                                this.globals.theoryexam = 0;
                            }
                            if(this.userData['examstatus'] == 0 && (settings.module >= 2 ) && settings.viva_first == 0)
                            {
                                this.globals.vivaexam = 0;
                                this.globals.theoryexam = 1;
                            }
                            if(this.userData['examstatus'] == 1 && (settings.module >= 2 ) && settings.viva_first == 0)
                            {
                                this.globals.vivaexam = 1;
                                this.globals.theoryexam = 0;
                            }        
                            if(this.userData['examstatus'] == 2 && settings.viva_assessor == 0 && (settings.module >= 2 ) && settings.viva_first == 1)
                            {
                                this.globals.vivaexam = 0;
                                this.globals.theoryexam = 1;
                            }
                            if(this.userData['examstatus'] == 2 && settings.viva_assessor == 1 && (settings.module >= 2 ) && settings.viva_first == 1)
                            {
                                this.globals.vivaexam = 0;
                                this.globals.theoryexam = 1;
                            }                            
                            if(this.userData['examstatus'] == 0 && settings.module == 1)
                            {
                                this.globals.vivaexam = 0;
                                this.globals.theoryexam = 1;
                            }                             
                            if (settings.camera == 1 && this.globals.theoryexam == 1) {
                                var parms = this.globals.getRandUrl('upload-idpic');
                                this.router.navigateByUrl('/upload-idpic/' + parms);
                            }
                            else {
                                var parms = this.globals.getRandUrl('test-start');
                                this.router.navigateByUrl('/test-start/' + parms);                                  
                            }
                        }
                        else if (data.status == 1001) {
                            this.loading = false;
                            this.isErrorLogin = false;
                            this.router.navigateByUrl('/login');
                        }
                        else {
                            this.isErrorLogin = true;
                            this.errorMsg = 'This is incorrect information!!';
                            this.loading = false;
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.isErrorLogin = true;
                        this.errorMsg = 'This is incorrect information!!';
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
    }    
        public AdaptiveverifyProfile() {
            this.loading = true;
            this.spinner.show();
            this.userData = JSON.parse(localStorage.getItem('currentUser'));
            var settings = JSON.parse(sessionStorage.pkshn_exam_set);
            this.geoIPData = JSON.parse(localStorage.getItem('supspw_geoIPStu'));
            this.geoType = JSON.parse(localStorage.getItem('supspw_geoIPStu_type'));
            var geoipresponse = this.geoIPData;
            if(this.geoType === 1)
            {
                if (geoipresponse != undefined) 
                {
                    var geoAddress = geoipresponse['display_name'];
                    this.latlong = geoipresponse['lat'] + ',' + geoipresponse['lon'];
                }
            }
            if(this.geoType === 2)
            {
                if (geoipresponse != undefined) 
                {
                    var geoAddress = geoipresponse['results'][0].formatted
                    this.latlong = geoipresponse['results'][0].geometry['lat'] + ',' + geoipresponse['results'][0].geometry['lng'];
                }
            } 

            this.verifystudentService.verifyStudentAdaptive(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.nameFormControl.value, this.genderFormControl.value, this.emailFormControl.value, this.mobileFormControl.value, this.qualiFormControl.value, this.aadharFormControl.value, this.stateFormControl.value, this.districtFormControl.value, geoAddress, this.latlong, settings.exam_id, this.birthdateFormControl.value)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {
                            this.isErrorLogin = false;                            
                            if (settings.camera == 1) {
                                var parms = this.globals.getRandUrl('upload-idpic');
                                this.router.navigateByUrl('/upload-idpic/' + parms);
                            }
                            else {
                                var parms = this.globals.getRandUrl('adaptive-test-start');
                                this.router.navigateByUrl('/adaptive-test-start/' + parms);                                  
                            }
                        }
                        else if (data.status == 1001) {
                            this.loading = false;
                            this.isErrorLogin = false;
                            this.router.navigateByUrl('/login');
                        }
                        else {
                            this.isErrorLogin = true;
                            this.errorMsg = 'This is incorrect information!!';
                            this.loading = false;
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.isErrorLogin = true;
                        this.errorMsg = 'This is incorrect information!!';
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
    }    
        public theory3verifyProfile() {
            this.loading = true;
            this.spinner.show();
            this.userData = JSON.parse(localStorage.getItem('currentUser'));
            var settings = JSON.parse(sessionStorage.pkshn_exam_set);
            this.geoIPData = JSON.parse(localStorage.getItem('supspw_geoIPStu'));
            this.geoType = JSON.parse(localStorage.getItem('supspw_geoIPStu_type'));
            var geoipresponse = this.geoIPData;
            if(this.geoType === 1)
            {
                if (geoipresponse != undefined) 
                {
                    var geoAddress = geoipresponse['display_name'];
                    this.latlong = geoipresponse['lat'] + ',' + geoipresponse['lon'];
                }
            }
            if(this.geoType === 2)
            {
                if (geoipresponse != undefined) 
                {
                    var geoAddress = geoipresponse['results'][0].formatted
                    this.latlong = geoipresponse['results'][0].geometry['lat'] + ',' + geoipresponse['results'][0].geometry['lng'];
                }
            } 

            this.verifystudentService.verifyStudentTheory3(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.nameFormControl.value, this.genderFormControl.value, this.emailFormControl.value, this.mobileFormControl.value, this.qualiFormControl.value, this.aadharFormControl.value, this.stateFormControl.value, this.districtFormControl.value, geoAddress, this.latlong, settings.exam_id, this.birthdateFormControl.value)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {
                            this.isErrorLogin = false;   
                            this.authStage();                         
                            if (settings.camera == 1) {
                                var parms = this.globals.getRandUrl('upload-idpic');
                                this.router.navigateByUrl('/upload-idpic/' + parms);
                            }
                            else {
                                var parms = this.globals.getRandUrl('test-start');
                                this.router.navigateByUrl('/test-start/'+parms);                                
                            }
                        }
                        else if (data.status == 1001) {
                            this.loading = false;
                            this.isErrorLogin = false;
                            this.router.navigateByUrl('/login');
                        }
                        else {
                            this.isErrorLogin = true;
                            this.errorMsg = 'This is incorrect information!!';
                            this.loading = false;
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.isErrorLogin = true;
                        this.errorMsg = 'This is incorrect information!!';
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
    }      
    public onSubmitMock() {
        this.submitted = true;
        /* stop here if form is invalid */
        if (this.nameFormControl.valid == false || this.genderFormControl.valid == false || this.emailFormControl.valid == false || this.mobileFormControl.valid == false || this.qualiFormControl.value == '' || this.stateFormControl.value == '' || this.districtFormControl.value == '') {
            this.isErrorLogin = false;
            return false;
        }
        else {
            this.loading = true;
            this.spinner.show();
            this.userData = JSON.parse(localStorage.getItem('currentUser'));
            var settings = JSON.parse(sessionStorage.pkshn_exam_set);
            this.geoIPData = JSON.parse(localStorage.getItem('supspw_geoIPStu'));
            this.geoType = JSON.parse(localStorage.getItem('supspw_geoIPStu_type'));
            var geoipresponse = this.geoIPData;
            if(this.geoType === 1)
            {
                if (geoipresponse != undefined) 
                {
                    var geoAddress = geoipresponse['display_name'];
                    this.latlong = geoipresponse['lat'] + ',' + geoipresponse['lon'];
                }
            }
            if(this.geoType === 2)
            {
                if (geoipresponse != undefined) 
                {
                    var geoAddress = geoipresponse['results'][0].formatted
                    this.latlong = geoipresponse['results'][0].geometry['lat'] + ',' + geoipresponse['results'][0].geometry['lng'];
                }
            } 

            this.verifystudentService.verifyStudent(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.nameFormControl.value, this.genderFormControl.value, this.emailFormControl.value, this.mobileFormControl.value, this.qualiFormControl.value, 0 , this.stateFormControl.value, this.districtFormControl.value, geoAddress, this.latlong, settings.exam_id)
                .pipe(first())
                .subscribe(
                    data => {
                        if (data.code == 1000) {
                            this.isErrorLogin = false;
                            if(this.userData['examstatus'] == 0 && settings.viva_assessor == 0 && (settings.module >= 2 ) && settings.viva_first == 1)
                            {
                                this.globals.vivaexam = 1;
                                this.globals.theoryexam = 0;
                            }
                            if(this.userData['examstatus'] == 0 && (settings.module >= 2 ) && settings.viva_first == 0)
                            {
                                this.globals.vivaexam = 0;
                                this.globals.theoryexam = 1;
                            }
                            if(this.userData['examstatus'] == 1 && (settings.module >= 2 ) && settings.viva_first == 0)
                            {
                                this.globals.vivaexam = 1;
                                this.globals.theoryexam = 0;
                            }        
                            if(this.userData['examstatus'] == 2 && settings.viva_assessor == 0 && (settings.module >= 2 ) && settings.viva_first == 1)
                            {
                                this.globals.vivaexam = 0;
                                this.globals.theoryexam = 1;
                            }
                            if(this.userData['examstatus'] == 0 && settings.module == 1)
                            {
                                this.globals.vivaexam = 0;
                                this.globals.theoryexam = 1;
                            }                             
                            if (settings.camera == 1 && this.globals.theoryexam == 1) {
                                var parms = this.globals.getRandUrl('upload-idpic');
                                this.router.navigateByUrl('/upload-idpic/' + parms);
                            }
                                else {
                                    if (settings.feedback_survey == 1) {
                                       //  console.log(settings.feedback_survey);
                                       this.router.navigateByUrl('/start-feedback');                                
                                    } 
                                    else
                                    {
                                        var parms = this.globals.getRandUrl('test-start');
                                        this.router.navigateByUrl('/test-start/' + parms);
                                    }                                  
                                }
                        }
                        else if (data.status == 1001) {
                            this.loading = false;
                            this.isErrorLogin = false;
                            this.router.navigateByUrl('/login');
                        }
                        else {
                            this.isErrorLogin = true;
                            this.errorMsg = 'This is incorrect information!!';
                            this.loading = false;
                        }
                        this.spinner.hide();
                    },
                    error => {
                        this.isErrorLogin = true;
                        this.errorMsg = 'This is incorrect information!!';
                        this.alertService.error(error);
                        this.loading = false;
                        this.spinner.hide();
                    }
                );
        }
    }
    public authStage(){
        this.authenticationService.authStage(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], 2)
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    console.log('Auth Stage 2 updated');
                }
            }
        );
    }     
}
